(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"]) return;
  try {
    
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');
  const firstTab = document.querySelector('.tab__list:first-child');

  tabs.forEach(tab => {
      tab.addEventListener('click', () => {
          const contentId = tab.dataset.contentId;
          const content = document.getElementById(contentId);

          tabContents.forEach(content => content.classList.remove('active'));
          tabs.forEach(tab => tab.classList.remove('active'));

          tab.classList.add('active');
          content.classList.add('active');

          // Remove background color from the first child if it's not the active tab
          if (tab !== firstTab.querySelector('.custom-tab')) {
              firstTab.classList.remove('first-child-active');
          } else {
              firstTab.classList.add('first-child-active');
          }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-tab"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');
  const firstTab = document.querySelector('.tab__list:first-child');

  tabs.forEach(tab => {
      tab.addEventListener('click', () => {
          const contentId = tab.dataset.contentId;
          const content = document.getElementById(contentId);

          tabContents.forEach(content => content.classList.remove('active'));
          tabs.forEach(tab => tab.classList.remove('active'));

          tab.classList.add('active');
          content.classList.add('active');

          // Remove background color from the first child if it's not the active tab
          if (tab !== firstTab.querySelector('.custom-tab')) {
              firstTab.classList.remove('first-child-active');
          } else {
              firstTab.classList.add('first-child-active');
          }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-section"]) return;
  try {
    
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');
  const firstTab = document.querySelector('.tab__list:first-child');

  tabs.forEach(tab => {
      tab.addEventListener('click', () => {
          const contentId = tab.dataset.contentId;
          const content = document.getElementById(contentId);

          tabContents.forEach(content => content.classList.remove('active'));
          tabs.forEach(tab => tab.classList.remove('active'));

          tab.classList.add('active');
          content.classList.add('active');

          // Remove background color from the first child if it's not the active tab
          if (tab !== firstTab.querySelector('.custom-tab')) {
              firstTab.classList.remove('first-child-active');
          } else {
              firstTab.classList.add('first-child-active');
          }
      });
  });

  } catch(e) { console.error(e); }
})();
})();
